import { axiosClient } from '../../clients/axios-client'
import type { ToggleFavoriteResponseDto } from './dtos/prompt'
import { ToggleFavoriteResponseDtoSchema } from './dtos/prompt'

export async function toggleFavoritePrompt(promptId: string): Promise<void> {
  try {
    const { data } = await axiosClient.post<ToggleFavoriteResponseDto>('/prompts/favorites', {
      prompt_id: promptId,
    })

    const { success, message } = ToggleFavoriteResponseDtoSchema.parse(data)
    if (!success) {
      throw new Error(`Toggle favorite failed for prompt ID: ${promptId}: ${message}`)
    }
  } catch (error) {
    console.error(`Toggle favorite failed. Prompt ID: ${promptId}`, error)
    throw error
  }
}
